

import React, { useState } from 'react';
import './Calculator.css';
import Trigonometry from './Trigonomentry';

const Calculator = () => {
  const [number, setNumber] = useState('');
  const [operation, setOperation] = useState('square');
  const [result, setResult] = useState(null);

  const handleNumberChange = (e) => {
    setNumber(e.target.value);
  };

  const handleOperationChange = (e) => {
    setOperation(e.target.value);
  };

  const calculateResult = () => {
    const num = parseFloat(number);
    if (isNaN(num)) return;

    let res;
    switch (operation) {
      case 'square':
        res = num * num;
        break;
      case 'squareRoot':
        res = Math.sqrt(num);
        break;
      case 'cubeRoot':
        res = Math.cbrt(num);
        break;
        case 'powerOf':
        res = Math.exp(num);
        break;
      case 'logOf':
        res = Math.log(num);
        break;
      default:
        res = null;
    }
    setResult(res);
  };

  return (
    <div className="calculator">
      <h1>Find out Square, Square-root, Cube-root, Power of, log() etc., of a number</h1>
      <div>
        <label>
          Number:
          <input type="number" value={number} onChange={handleNumberChange} />
        </label>
      </div>
      <div>
        <label>
          Operation:
          <select value={operation} onChange={handleOperationChange}>
            <option value="square">Square</option>
            <option value="squareRoot">Square Root</option>
            <option value="cubeRoot">Cube Root</option>
            <option value="powerOf">Power of</option>
            <option value="logOf">Log of</option>
          </select>
        </label>
      </div>
      <button onClick={calculateResult}>Calculate</button>
      {result !== null && <div className="result">Result: {result}</div>}
      <br/>
      <Trigonometry/>
    </div>
  );
};

export default Calculator;
